import { InvestmentJurisdictionWithNestedObjectsResponseAuditable } from '../../../../web-api-client';
import { InvestmentJurisdiction } from '../../models';
import { mapCountryFromResponse } from '../country/map-country-from-response';

export const mapInvestmentJurisdictionFromResponse = (
  response: InvestmentJurisdictionWithNestedObjectsResponseAuditable
): InvestmentJurisdiction => ({
  investmentJurisdictionId: response.investmentJurisdictionId!,
  name: response.country ? mapCountryFromResponse(response.country).name : '',
  country: response.country
    ? mapCountryFromResponse(response.country)
    : undefined,
  region: response.country?.region?.name ?? '',
  isActive: response.isActive ?? false,
  isDisplay: response.isDisplay ?? false,
  modified: response.modified!,
});
